import { BRAND } from '../login/brand';

// Dashboard palette built on the Core Loan Hub brand. `accent` is the theme's
// primary copper, which keeps white button text at WCAG AA contrast.
export const DASH = {
  accent: '#9A5C27',
  copper: BRAND.copper,
  sand: BRAND.sand,
  brown: BRAND.brown,
  brownDeep: BRAND.brownDeep,
  ink: BRAND.ink,
  muted: BRAND.muted,
  border: BRAND.border,
  success: BRAND.success,
  cream: '#FBF6EE',
  creamDeep: '#F3E4CC',
};

/** Fast Funding uses copper; SBA uses the deep brand brown. */
export const flowColor = (type) => (type === 'sba' ? DASH.brown : DASH.accent);
